import React from 'react'

const Loader = () => {
//   return (
//     <>
//       <div className='m-loader'>
//         <div className='m-loader--rounds'>
//           <span></span>
//           <span></span>
//           <span></span>
//           <span></span>
//         </div>
//       </div>
//     </>
//   )

return (
    <div className="main-loading">
      <div className="loading">
        <span className="bar"></span>
      </div>
    </div>
  );
}

export default Loader
